import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import Content from '../components/Content';
import BookReleasesDateTabs from '../components/book/BookReleasesDateTabs';
import BookReleasesTable from '../components/book/BookReleasesTable';

const DATE_FORMAT = 'YYYY-MM-DD';

const parseDateParam = (param) => {
  if (param && moment(param, DATE_FORMAT, true).isValid()) {
    return moment(param, DATE_FORMAT).startOf('day');
  }
  return moment().startOf('day');
};

const BookReleases = ({ userStore }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedDate, setSelectedDate] = useState(() => parseDateParam(searchParams.get('date')));

  const handleDateChange = (date) => {
    const normalized = moment(date).startOf('day');
    setSelectedDate(normalized);
    setSearchParams({ date: normalized.format(DATE_FORMAT) });
  };

  return (
    <Content title='Lançamentos de livros' userStore={userStore}>
      <BookReleasesDateTabs
        initialDate={selectedDate}
        onDateChange={handleDateChange}
      />
      <br />
      <BookReleasesTable selectedDate={selectedDate} userStore={userStore} />
    </Content>
  );
};

export default BookReleases;